export default "__VITE_ASSET__Cj_cxT9F__"